import { CoreIcon } from '../core-icon';
import playCircleSVG from '../../assets/icons/play-circle.svg';
import type { IconProps } from '../core-icon';

export const PlayCircleIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={playCircleSVG} {...props} />;
};
